import React, { Component } from 'react';

if (typeof window !== 'undefined') {
    require('intersection-observer');
}

interface ScrollObserverProps {
    onReach: () => void;
    onUnreach: () => void;
    intersectionObserverOptions?: IntersectionObserverInit;
    scrollBorder?: 'top' | 'bottom';
}

export class ScrollObserver extends Component<ScrollObserverProps> {
    componentDidMount() {
        if ('IntersectionObserver' in window) {
            try {
                this.observer = this.createObserver();
                this.observer.observe(this.scrollObservableRef);
            } catch (e) {
                console.error('Error initializing intersection observer');
            }
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.unobserve(this.scrollObservableRef);
        }
    }

    private reached = false;
    private observer?: IntersectionObserver;
    private scrollObservableRef: HTMLDivElement;

    createObserver() {
        const { intersectionObserverOptions = {}, onReach, onUnreach, scrollBorder } = this.props;

        const defaultOptions = {
            root: null,
            rootMargin: '0px',
            thresholds: [0, 1],
        };

        const options = {
            ...defaultOptions,
            ...intersectionObserverOptions,
        };

        return new IntersectionObserver((entries) => {
            const entry = entries[0];

            if (entry.rootBounds === null) {
                return;
            }

            const entryPosition = entry.boundingClientRect.top;
            const borderPosition = entry.rootBounds[scrollBorder || 'top'];

            if (!this.reached && entryPosition < borderPosition) {
                this.reached = true;
                onReach();
            } else if (this.reached && entryPosition >= borderPosition) {
                this.reached = false;
                onUnreach();
            }
        }, options);
    }

    onScrollObservableRef = (ref: HTMLDivElement) => {
        this.scrollObservableRef = ref;
    };

    render() {
        return <div ref={this.onScrollObservableRef} />;
    }
}
